/* Glyfa Theme · Seitenverhalten (Menü, Warenkorb-Zähler, Einblenden, Countdown, Live-Vorschau, Produktauswahl, Filter, Rechner, Drop-Warenkorb).
   Klassisches Skript, abhängig von glyfa-art.js (window.GlyfaArt) und window.GLYFA (Einstellungen, Texte, Routen). */
(function () {
  'use strict';
  var G = window.GLYFA || {};
  var I = G.i18n || {};
  var R = G.routes || { cart: '/cart', cartAdd: '/cart/add', root: '/' };
  var Art = window.GlyfaArt;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function t(key, vars) {
    var s = I[key] != null ? I[key] : key;
    if (vars) for (var n in vars) s = s.split('__' + n + '__').join(vars[n]);
    return s;
  }
  function money(cents) {
    try { return new Intl.NumberFormat(G.locale || 'de-DE', { style: 'currency', currency: G.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + (G.currency || 'EUR'); }
  }
  window.GlyfaUtil = { t: t, money: money, $: $, $$: $$ };

  /* ---- Toast ---- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('on'); }, 2800);
  }
  window.GlyfaUtil.toast = toast;

  /* ---- Menü ---- */
  var menuBtn = $('[data-menu]');
  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      var open = document.body.classList.toggle('menu-open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
    $$('#nav a').forEach(function (a) {
      a.addEventListener('click', function () { document.body.classList.remove('menu-open'); menuBtn.setAttribute('aria-expanded', 'false'); });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.body.classList.remove('menu-open'); menuBtn.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---- Warenkorb ---- */
  function paintCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = String(n); el.dataset.n = String(n); });
  }
  function refreshCart() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () {});
  }
  function addItems(items) {
    return fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { var e = new Error(j.description || j.message || 'cart error'); e.status = r.status; throw e; });
      return r.json();
    }).then(function (j) { refreshCart(); return j; });
  }
  window.GlyfaCart = { addItems: addItems, refresh: refreshCart };

  /* ---- Einblenden ---- */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('shown'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('shown'); });
  }

  /* ---- Sticky-CTA ---- */
  var sticky = $('[data-sticky]');
  if (sticky) {
    var upd = function () { sticky.classList.toggle('on', window.scrollY > 520); };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---- Countdown (echte Frist aus dem Metafeld; Beispiel-Drops laufen rollierend) ---- */
  var cds = $$('[data-countdown]');
  if (cds.length) {
    var tick = function () {
      cds.forEach(function (el) {
        var dl = Number(el.dataset.countdown) * 1000;
        var rolling = el.dataset.rolling === 'true';
        var step = Number(el.dataset.windowDays || 10) * 86400000;
        var now = Date.now();
        if (rolling && dl <= now) dl += Math.ceil((now - dl) / step + 0.0001) * step;
        var ended = dl <= now;
        el.classList.toggle('ended', ended);
        var s = Math.max(0, Math.floor((dl - now) / 1000));
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var set = function (k, v) { var n = $('[data-' + k + ']', el); if (n) n.textContent = String(v).padStart(2, '0'); };
        set('d', d); set('h', h); set('m', m); set('s', s);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Beispiel-Logos und Farben ---- */
  function sampleLogo(id) {
    var s = Art && Art.SAMPLE_LOGOS[id];
    return s ? { kind: 'markup', w: s.w, h: s.h, markup: s.markup } : null;
  }
  function colorKey(v) {
    v = String(v || '').toLowerCase();
    if (v === 'natur' || v === 'papier' || v === 'natural') return 'papier';
    if (v === 'sand') return 'sand';
    if (v === 'moos' || v === 'moss') return 'moos';
    return 'tinte';
  }
  window.GlyfaUtil.sampleLogo = sampleLogo;
  window.GlyfaUtil.colorKey = colorKey;

  /* ---- Art-Slots (Produktgrafik, wenn kein Produktbild hinterlegt ist) ---- */
  function hydrateArt(root) {
    if (!Art) return;
    $$('[data-glyfa-art]', root).forEach(function (el) {
      if (el.dataset.done) return;
      var kind = el.dataset.kind;
      if (Art.KINDS.indexOf(kind) < 0) return;
      el.innerHTML = Art.productSVG(kind, {
        color: el.dataset.color || 'tinte',
        logo: sampleLogo(el.dataset.logo || 'mrc'),
        view: el.dataset.view || 'front',
        name: el.dataset.name || '', number: el.dataset.number || '', title: '',
        bg: el.dataset.bg === 'none' ? false : undefined
      });
      el.dataset.done = '1';
    });
  }
  hydrateArt(document);
  document.addEventListener('shopify:section:load', function (e) { hydrateArt(e.target); });

  /* ---- Live-Vorschau (Start-Hero) ---- */
  function renderStage(root) {
    var view = $('[data-stage-view]', root);
    var st = root._st;
    view.innerHTML = Art.productSVG(st.kind, { color: st.color, logo: sampleLogo(st.logo), view: 'front', title: '' });
  }
  $$('[data-stage]').forEach(function (root) {
    if (!Art) return;
    root._st = { kind: root.dataset.kind, color: root.dataset.color, logo: root.dataset.logo };
    var touched = false;
    function sync() {
      $$('[data-color-pick]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.colorPick === root._st.color)); });
      $$('[data-logo-pick]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.logoPick === root._st.logo)); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.colorPick) root._st.color = b.dataset.colorPick;
      else if (b.dataset.logoPick) root._st.logo = b.dataset.logoPick;
      else return;
      touched = true;
      sync();
      renderStage(root);
    });
    renderStage(root);
    if (root.hasAttribute('data-cycle') && !reduce) {
      var kinds = ['hoodie', 'tshirt', 'beanie', 'socken'];
      var cols = ['tinte', 'sand', 'moos', 'papier'];
      var i = 0;
      setInterval(function () {
        if (touched || document.hidden) return;
        i = (i + 1) % kinds.length;
        root._st.kind = kinds[i];
        root._st.color = cols[i % cols.length];
        var v = $('[data-stage-view]', root);
        v.style.transition = 'opacity .25s';
        v.style.opacity = '0';
        setTimeout(function () { sync(); renderStage(root); v.style.opacity = '1'; }, 260);
      }, 4200);
    }
  });

  /* ---- Produktseite: Varianten, Galerie, Grafik ---- */
  $$('[data-product]').forEach(function (root) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) { variants = []; }
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var addBtn = $('[data-add-direct]', root);
    var kind = root.dataset.kind;
    var logo = root.dataset.logo || 'mrc';
    var view = 'front';
    var mainEl = $('[data-main]', root);
    var hasMedia = root.dataset.hasMedia === 'true';
    var configLink = $('[data-config-link]', root);

    function selected() {
      var vals = [];
      $$('fieldset[data-option]', root).forEach(function (fs) {
        var c = $('input:checked', fs);
        vals[Number(fs.dataset.option)] = c ? c.value : null;
        var lab = $('[data-option-label]', fs);
        if (lab && c) lab.textContent = c.value;
      });
      return vals;
    }
    function findVariant(vals) {
      return variants.find(function (v) {
        return (vals[0] == null || v.o1 === vals[0]) && (vals[1] == null || v.o2 === vals[1]) && (vals[2] == null || v.o3 === vals[2]);
      });
    }
    function showMedia(id) {
      $$('[data-media]', root).forEach(function (m) { m.hidden = String(m.dataset.media) !== String(id); });
      $$('[data-media-thumb]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(String(b.dataset.mediaThumb) === String(id))); });
    }
    function renderArt() {
      if (hasMedia || !Art) return;
      var vals = selected();
      var holder = $('[data-art-main]', root);
      if (holder) {
        holder.innerHTML = Art.productSVG(kind, { color: colorKey(vals[0]), logo: sampleLogo(logo), view: view, name: t('pdp.your_name'), number: '07', title: '' });
      }
    }
    function update() {
      var vals = selected();
      var v = findVariant(vals);
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? t('pdp.add_direct') : t('pdp.sold_out');
        }
        if (v.media) showMedia(v.media);
        else if (hasMedia && v.o1) {
          var hit = $$('[data-media-thumb]', root).filter(function (b) {
            var l = (b.getAttribute('aria-label') || '').toLowerCase();
            return l.indexOf(String(v.o1).toLowerCase()) >= 0 && l.indexOf('rück') < 0 && l.indexOf('back') < 0;
          })[0];
          if (hit) showMedia(hit.dataset.mediaThumb);
        }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      }
      if (configLink) {
        try {
          var cu = new URL(configLink.getAttribute('href'), location.origin);
          cu.searchParams.set('product', root.dataset.handle);
          if (vals[0]) cu.searchParams.set('color', vals[0]);
          if (vals[1]) cu.searchParams.set('size', vals[1]);
          configLink.setAttribute('href', cu.pathname + cu.search);
        } catch (e) {}
      }
      renderArt();
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('fieldset[data-option] input')) update();
    });
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-media-thumb]');
      if (th) { showMedia(th.dataset.mediaThumb); return; }
      var lp = e.target.closest('[data-logo-pick]');
      if (lp) {
        logo = lp.dataset.logoPick;
        $$('[data-logo-pick]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === lp)); });
        renderArt();
        return;
      }
      var vp = e.target.closest('[data-view-pick]');
      if (vp) {
        view = vp.dataset.viewPick;
        $$('[data-view-pick]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === vp)); });
        renderArt();
      }
    });
    // Direkt-Kauf (optional, Theme-Einstellung)
    var form = $('[data-direct-form]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = Number(idInput.value);
        addBtn.disabled = true;
        addItems([{ id: vid, quantity: 1 }]).then(function () { toast(t('toast.added')); }).catch(function (err) { toast(err.message); }).then(function () { addBtn.disabled = false; });
      });
    }
    update();
  });

  /* ---- Filter in der Kollektion ---- */
  $$('[data-filter]').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var f = b.dataset.filter;
      $$('[data-grid] .pcard').forEach(function (c) { c.hidden = f !== 'all' && (c.dataset.tracks || '').split(' ').indexOf(f) < 0; });
    });
  });

  /* ---- Provisions-Rechner ---- */
  $$('[data-calc]').forEach(function (el) {
    var price = Number(el.dataset.price), vat = Number(el.dataset.vat), com = Number(el.dataset.commission);
    var range = $('[data-calc-range]', el), out = $('[data-calc-out]', el), n = $('[data-calc-n]', el), det = $('[data-calc-detail]', el);
    function upd() {
      var orders = Number(range.value);
      var net = price / (1 + vat);
      var per = net * com;
      out.textContent = money(Math.round(per * orders) * 100).replace(/[,.]00(?=\s| |$)/, '');
      n.textContent = String(orders);
      det.textContent = money(per * 100) + ' ' + t('calc.per_order') + ' = ' + Math.round(com * 100) + ' % ' + t('calc.of') + ' ' + money(net * 100) + ' ' + t('calc.net');
    }
    range.addEventListener('input', upd);
    upd();
  });

  /* ---- Drop: Vorbestellen (Varianten wählen, in den Warenkorb) ---- */
  $$('[data-drop-item]').forEach(function (card) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', card).textContent); } catch (e) { variants = []; }
    var btn = $('[data-add-one]', card);
    var sizes = $$('input[data-size]', card);
    function chosen() {
      var c = sizes.filter(function (x) { return x.checked; })[0];
      return c ? c.value : null;
    }
    btn.addEventListener('click', function () {
      var size = chosen();
      if (sizes.length && !size) { toast(t('drop.choose_size')); return; }
      var v = variants.filter(function (x) { return !sizes.length || x.o2 === size; })[0];
      if (!v || !v.available) { toast(t('pdp.sold_out')); return; }
      btn.disabled = true;
      addItems([{ id: v.id, quantity: 1, properties: { _drop: card.dataset.drop, Drop: card.dataset.dropTitle } }])
        .then(function () { toast(t('drop.added')); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.disabled = false; });
    });
  });

  /* ---- Drop: Bundle (Hoodie + Socken + Beanie) ---- */
  $$('[data-bundle]').forEach(function (box) {
    var btn = $('[data-bundle-add]', box);
    var lines = $$('[data-bundle-line]', box).map(function (ln) {
      var variants = [];
      try { variants = JSON.parse($('[data-variants]', ln).textContent); } catch (e) { variants = []; }
      return { el: ln, variants: variants, sizes: $$('input[data-size]', ln) };
    });
    btn.addEventListener('click', function () {
      var items = [];
      for (var i = 0; i < lines.length; i++) {
        var ln = lines[i];
        var c = ln.sizes.filter(function (x) { return x.checked; })[0];
        if (ln.sizes.length && !c) { toast(t('drop.choose_size')); return; }
        var v = ln.variants.filter(function (x) { return !ln.sizes.length || x.o2 === c.value; })[0];
        if (!v || !v.available) { toast(t('pdp.sold_out')); return; }
        items.push({ id: v.id, quantity: 1, properties: { _bundle: box.dataset.drop, Drop: box.dataset.dropTitle } });
      }
      btn.disabled = true;
      addItems(items).then(function () { toast(t('drop.added_bundle')); }).catch(function (err) { toast(err.message); }).then(function () { btn.disabled = false; });
    });
  });

  /* ---- Kontakt: Thema aus der Adresse (?topic=drop|team|frage) vorwählen ---- */
  var topic = $('[data-topic]');
  if (topic) {
    var wanted = new URLSearchParams(location.search).get('topic');
    if (wanted) {
      $$('option', topic).forEach(function (o) { if (o.dataset.key === wanted) topic.value = o.value; });
    }
  }

  refreshCart();
})();
